import { useIntl } from 'react-intl';
import { Hook } from '@rossum/api-client/hooks';
import { Button, Chip, CircularProgress } from '@rossum/ui/material';
import { useUpdate } from '../hooks/useUpdate';
import { useVersions } from '../hooks/useVersions';
import { fromUpstreamMetadata, Upstream } from '../upstreamSchema';

export const UpdateButton = ({
  selectedExtension,
}: {
  selectedExtension: Hook;
}) => {
  const upstream = fromUpstreamMetadata(selectedExtension.metadata);

  return upstream ? (
    <UpdateButtonContent upstream={upstream} hookId={selectedExtension.id} />
  ) : null;
};

export const UpdateButtonContent = ({
  upstream,
  hookId,
}: {
  upstream: Upstream;
  hookId: number;
}) => {
  const intl = useIntl();
  const { externalHookTemplateId, version, hookInterfaceId } = upstream;

  const { data: versions, isSuccess: versionsLoaded } = useVersions({
    hookInterfaceId,
    externalHookTemplateId,
  });

  const latestVersion = versions?.[0];

  const isStoreOutdated = versionsLoaded && latestVersion !== version;

  const { mutate: update, isLoading: isUpdating } = useUpdate({
    hookId,
  });

  return (
    <>
      <Chip
        key="custom-store-version-chip"
        label={`${intl.formatMessage({ id: 'features.externalStore.detail.version' })}: ${version}`}
      />

      {isStoreOutdated ? (
        <Button
          key="update-custom-store-version-button"
          startIcon={
            isUpdating ? (
              <CircularProgress size={16} color="inherit" />
            ) : undefined
          }
          onClick={() => {
            if (latestVersion)
              update({
                version: latestVersion,
                externalHookTemplateId,
                hookInterfaceId,
              });
          }}
          variant="outlined"
          color="warning"
        >
          {intl.formatMessage({ id: 'features.externalStore.detail.update' })}
        </Button>
      ) : null}
    </>
  );
};
